import React, { useMemo, useState } from 'react'
import DatePicker, { ReactDatePickerCustomHeaderProps } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './ReactDatePicker.css'
import moment from 'moment'
import {
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
} from 'react-icons/fa'

export type ReactDatePickerProps = React.ComponentProps<typeof DatePicker> & {}

export const ReactDatePicker = (props: ReactDatePickerProps) => {
  const { className, ...rest } = props
  const [currentMonth, setCurrentMonth] = useState(moment())
  return (
    <DatePicker
      showYearDropdown
      yearDropdownItemNumber={100}
      scrollableYearDropdown
      dateFormatCalendar="MMMM"
      renderCustomHeader={(props: ReactDatePickerCustomHeaderProps) => (
        <ReactDatePickerHeader {...props} />
      )}
      onMonthChange={(date) => setCurrentMonth(moment(date))}
      maxDate={moment().toDate()}
      minDate={moment('1900-01-01').toDate()}
      dateFormat="yyyy-MM-dd"
      className="full-width custom-input padding"
      {...rest}
    />
  )
}

export const ReactDatePickerHeader = (
  props: ReactDatePickerCustomHeaderProps,
) => {
  const { date, increaseMonth, decreaseMonth, changeYear } = props

  const [showYears, setShowYears] = useState(false)

  const month = useMemo(
    () => (moment ? moment(date).format('MMMM') : ''),
    [date],
  )
  const year = useMemo(
    () => (moment ? moment(date).format('YYYY') : ''),
    [date],
  )

  const currentYear = useMemo(() => parseInt(moment().format('YYYY')), [year])
  const years = useMemo(
    () => new Array(100).fill(0).map((_, i) => currentYear - i),
    [currentYear],
  )

  console.log('years', years)

  console.log('parse', parseInt(moment().format('YYYY')))
  return (
    <div className="date-picker-header-container">
      <FaChevronLeft
        cursor="pointer"
        size={12}
        color="black"
        onClick={decreaseMonth}
      />
      <span className="date-picker-header-item">
        {month}
        <div
          onClick={() => setShowYears((t) => !t)}
          className="date-picker-year-selector-container"
        >
          {year}
          {showYears ? (
            <FaChevronDown size={12} color="black" />
          ) : (
            <FaChevronUp size={12} color="black" />
          )}
          {showYears && (
            <div className="date-picker-year-selector">
              {new Array(100)
                .fill(0)
                .map((_, i) => {
                  return currentYear - i
                })
                .map((year) => (
                  <div
                    className="date-picker-selector-item"
                    onClick={() => changeYear(year)}
                  >
                    {year}
                  </div>
                ))}
            </div>
          )}
        </div>
      </span>
      <FaChevronRight
        cursor="pointer"
        size={12}
        color="black"
        onClick={increaseMonth}
      />
    </div>
  )
}
